import { render, staticRenderFns } from "./CorreccionSecciones.vue?vue&type=template&id=32d4f77c&scoped=true"
import script from "./CorreccionSecciones.vue?vue&type=script&lang=js"
export * from "./CorreccionSecciones.vue?vue&type=script&lang=js"
import style0 from "./CorreccionSecciones.vue?vue&type=style&index=0&id=32d4f77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d4f77c",
  null
  
)

export default component.exports